import { render, staticRenderFns } from "./LKHeaderItem.vue?vue&type=template&id=46f50e51&"
import script from "./LKHeaderItem.vue?vue&type=script&lang=js&"
export * from "./LKHeaderItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports